webpackJsonp([146451445218038],{

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(22);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _subNav = __webpack_require__(29);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_React$Component) {
	  _inherits(Project, _React$Component);
	
	  function Project() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Project);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setLandscape = function () {
	      if (_this.imageGrid) {
	        var children = Array.from(_this.imageGrid.children);
	
	        for (var _iterator = children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var div = _ref;
	
	          var image = div.querySelector('img');
	          var landscape = image.naturalHeight < image.naturalWidth;
	          if (landscape) div.classList.add('landscape');
	        }
	      }
	    }, _this.handleImageLoad = function (i) {
	      if (i === _this.props.data.cosmicjsProjects.metadata.images.length - 1) {
	        _this.setLandscape();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Project.prototype.componentDidMount = function componentDidMount() {
	    this.setLandscape();
	  };
	
	  Project.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	    var _data$cosmicjsProject = data.cosmicjsProjects,
	        title = _data$cosmicjsProject.title,
	        content = _data$cosmicjsProject.content,
	        _data$cosmicjsProject2 = _data$cosmicjsProject.metadata,
	        images = _data$cosmicjsProject2.images,
	        imgix_url = _data$cosmicjsProject2.hero.imgix_url;
	
	
	    return _react2.default.createElement(
	      _gatsbyPluginPageTransitions2.default,
	      { transitionTime: 750 },
	      _react2.default.createElement(
	        'div',
	        { className: 'Project__container' },
	        _react2.default.createElement(_subNav2.default, { navLinks: ['Home', 'Projects', 'Contact', 'About', 'News'] }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          title
	        ),
	        _react2.default.createElement('img', { className: 'Project__Jumbo', src: imgix_url, alt: title }),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: content } }),
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(node) {
	              return _this2.imageGrid = node;
	            }, className: 'Project__brick' },
	          images.map(function (_ref2, i) {
	            var image = _ref2.image;
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', {
	                className: 'Project__Img',
	                key: i,
	                src: image.imgix_url,
	                alt: title,
	                onLoad: function onLoad() {
	                  return _this2.handleImageLoad(i);
	                }
	              })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Project;
	}(_react2.default.Component);
	
	exports.default = Project;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-project-template-js-e84a58fd26a058cec657.js